module.exports = require("./../../_gen/starling/text/BitmapCharLocation");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/text/BitmapCharLocation.js
// module id = 224
// module chunks = 0